'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export function useCloseOnNavigation(onNavigate: () => void) {
  const router = useRouter();

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a[href]') as HTMLAnchorElement | null;

      if (link && link.href.startsWith(location.origin)) {
        onNavigate();
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [onNavigate, router]);
}
